<template>
  <div>
    <div class="mainbox">
      <div class="err">404</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error'
}
</script>

<style scoped lang="scss">
  .mainbox {
    width: 100%;
    .err {
      color: black;
      font-family: 'Nunito Sans', sans-serif;
      font-size: 11rem;
      margin: auto;
      text-align: center;
      transform: translateY(70%);
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/Error.vue